module.exports = __webpack_public_path__ + "media/luxury-2026/classic-breakfast-960-e4fd0caa.jpg";